// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {ViewOptions} from 'backbone';
import * as d3 from 'd3';
import $ from 'jquery';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import * as biojs from 'BioJS';
import {
  MapType,
  SliceComponentName,
  MINI_MAP_Y_COMPONENTS,
  MINI_MAP_Z_COMPONENTS,
  LINEAR_INLINE_LAYERS,
  SliceMapType,
} from 'constants/MapsConstants';
import CutSite from 'molbio/enzymes/backbone/CutSite';
import {Enzyme, EnzymeType} from 'molbio/enzymes/backbone/Enzymes';
import {EnzymePreferences} from 'molbio/enzymes/EnzymeConstants';
import CutsiteMap from 'molbio/maps/linear/CutsiteMap';
import {InputBubblePositionDetails} from 'molbio/maps/linear/InputBubbleView';
import Slice from 'molbio/maps/linear/Slice';
import Slices from 'molbio/maps/linear/Slices';
import {SliceView} from 'molbio/maps/linear/SliceView';
import TitleView from 'molbio/maps/linear/TitleView';
import {MiniMapState} from 'molbio/maps/MapStates';
import PolymerMapTabView from 'molbio/maps/PolymerMapTabView';
import {foreignObjectRenderingEnabled} from 'molbio/maps/SequenceMapConstants';
import SequenceMapUtil, {ShowInputBubbleOptions} from 'molbio/maps/SequenceMapUtil';
import Type from 'molbio/maps/Type';
import {trackSequenceMapTabView} from 'molbio/SequenceAnalyticsHelper';
import * as sequtil from 'molbio/SeqUtil';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import * as Perf from 'performance/Perf';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import getTestProps from 'test/lib/cypress/getTestProps';
import {MouseWheelEvent} from 'util/Mouse';
import throttle from 'util/throttle';
import {ElementWheelEvent} from 'util/Types';

class MiniMap extends PolymerMapTabView<MiniMapTabState> {
  mapstate!: MiniMapState;
  sliceView!: SliceView;
  slice!: Slice;
  slices!: Slices;
  mapLoadPerfId!: Perf.PerfId;
  type!: Type;
  mapType!: MapType;
  lastMouseX!: number | null;
  debouncedUpdateCutsiteData!: () => void;
  titleView!: TitleView;

  static override initClass(): void {
    this.prototype.id = 'mini-map';
    this.prototype.className = 'draggable-svg-container buffer-tab';
    this.prototype.attributes = {
      ...this.prototype.attributes,
      ...getTestProps({component: 'MiniMap', element: 'root'}),
    };
  }

  override initialize(options: ViewOptions<MiniMapTabState>): void {
    super.initialize(options);
    this.mapLoadPerfId = Perf.start('loadMiniMap', {enabled: false});
    this.mapstate = this.model.get('mapstate');
    this.slice = new Slice();
    this.slices = new Slices([this.slice]);
    this.type = this.mapstate.get('layout').DNA.get('type');
    this.mapType = MapType.MINIMAP;
    this.setSliceValues(true);

    this.lastMouseX = null;

    this.sliceView = new SliceView({
      slice: this.slice,
      model: this.mapstate,
      tabstate: this.model,
      selection: this.mapstate.polymer().selection(),
      mapType: SliceMapType.minimap,
      y: MINI_MAP_Y_COMPONENTS,
      z: MINI_MAP_Z_COMPONENTS,
      svgSupportsForeignObject: foreignObjectRenderingEnabled(),
    });
    trackSequenceMapTabView(this.mapstate.get('sequence'), this.model.get('title'));
    this.debouncedUpdateCutsiteData = debounce(this.updateCutsiteData.bind(this), 1);
  }

  override events(): Backbone.EventsHash {
    return {...super.events(), scroll: 'storeScroll', mousemove: 'saveMouseCoordinates'};
  }

  saveMouseCoordinates(e: JQueryEventObject): void {
    this.lastMouseX = e.pageX;
  }

  addPolymersForSearch(): void {
    SequenceMapUtil.addPolymersForSearch(this.model.get('sequence'));
  }

  removePolymersForSearch(): void {
    SequenceMapUtil.removePolymersForSearch(this.model.get('sequence'));
  }

  storeScroll(): void {
    const scroll = this.$el.scrollLeft();
    const leftBP = Math.floor(
      (scroll / parseInt(d3.select(this.el).select('svg.mini-map').attr('width'), 10)) *
        this.mapstate.get('sequence').length()
    );
    const rightBP = Math.min(
      leftBP + this.type.numChars(this.model.get('bufferViewLayout')!.get('width')),
      this.mapstate.get('sequence').length()
    );
    this.slice.set({leftBP, rightBP}); // for rendering
    this.mapstate.set('leftBP', leftBP); // for restoring state
    if (this.mapstate.get('sequence').get('selection').get('active') && this.lastMouseX != null) {
      this.sliceView.updateSelectionFromScroll(this.lastMouseX);
      document.getSelection()?.removeAllRanges();
    }
  }

  isValidCharacter(char: string): boolean {
    return biojs.util.isValidBase(char, this.mapstate.get('sequence').get('_sequence').baseTable());
  }

  restoreScroll(): void {
    this.goToBase(this.mapstate.get('leftBP'), false, this.mapstate.get('rightBP'));
  }

  storeRegionInBenchlingClipboard(e: JQueryEventObject): string {
    return SequenceMapUtil.maybeStoreNucleotideRegionInBenchlingClipboard(
      this.mapstate.get('sequence').selection(),
      e
    )!;
  }

  handlePasteText(text: string): void {
    SequenceMapUtil.handlePasteText(this.mapstate.get('sequence'), text);
  }

  handleCtrlShiftC(e: JQueryEventObject): void {
    SequenceMapUtil.handleCtrlShiftC(this.mapstate.get('sequence'), e);
  }

  supportCutsites(): boolean {
    return true;
  }

  maxBases(): number {
    return this.mapstate.get('sequence').length();
  }

  getHeight(): number {
    return parseInt(this.$('svg').attr('height'), 10) + 25;
  }

  setZooms(): void {
    // Calculate minFontWidth and maxFontWidth
    d3.select('svg.mini-map-title').attr('width', this.model.get('bufferViewLayout')!.get('width'));
    const minFontWidth =
      this.mapstate.get('sequence').length() === 0
        ? 1
        : (this.model.get('bufferViewLayout')!.get('width') - 30) / this.mapstate.get('sequence').length();

    // Calculate maxFont
    const maxFontWidth =
      this.model.get('bufferViewLayout')!.get('width') / this.mapstate.get('sequence').length() > 30
        ? minFontWidth
        : 30;

    this.mapstate.setFontWidthRange(minFontWidth, maxFontWidth);
  }

  // This function doesn't seem to be used anywhere, maybe can remove
  calcScroll(): number {
    // this is called whenever we want to go to a specific base by buffers, so lets call goToBase manually
    return this.sliceView.boxHeight();
  }

  override remove(): this {
    this.sliceView.die();
    return super.remove();
  }

  updateSelection(): void {
    const selection = this.mapstate.get('sequence').get('selection');
    selection.set({active: null});
  }

  goToBase(base: number, animate: boolean | null, otherBase: number | null = null): void {
    if (animate == null) {
      animate = true;
    }
    const baseToScroll = (base: number): number =>
      (base / this.mapstate.get('sequence').length()) *
      parseInt(d3.select(this.el).select('svg.mini-map').attr('width'), 10);
    const scrollLeft = this.$el.scrollLeft();
    const scrollRight = scrollLeft + this.$el.width();
    const scroll = baseToScroll(base);
    const otherScroll = otherBase != null ? baseToScroll(otherBase) : scroll;

    let targetLeft;
    if (!(scrollLeft < scroll && scroll < scrollRight)) {
      targetLeft = scroll;
    } else if (otherBase != null && !(scrollLeft < otherScroll && otherScroll < scrollRight)) {
      targetLeft = Math.min(scroll, otherScroll - this.$el.width());
    } else {
      targetLeft = null;
    }

    if (targetLeft != null) {
      if (animate) {
        this.$el.stop(true, false).animate({scrollLeft: targetLeft}, 500);
      } else {
        this.$el.scrollLeft(targetLeft);
      }
    }
  }

  handleZoom(): void {
    const selection = this.mapstate.get('sequence').get('selection');

    const [leftBP, rightBP] = [this.mapstate.get('leftBP'), this.mapstate.get('rightBP')];
    const [startBP, endBP] = [selection.start(), selection.isEmpty() ? selection.start() : selection.end()];

    const wasVisible = sequtil.isRangeOverlap(leftBP, rightBP, startBP, endBP!);

    if (wasVisible) {
      this.mapstate.set({leftBP: startBP, rightBP: endBP!});
    }

    this.update();
    this.restoreScroll();
    this.repositionBubble();
  }

  mapWidth(): number {
    return this.model.get('bufferViewLayout')!.get('width') - 30;
  }

  override _getBubbleOffsetClass(): string {
    return '.body-slice';
  }

  showInputBubble(options: ShowInputBubbleOptions): void {
    SequenceMapUtil.showInputBubble(this, options);
  }

  override _calculateBubblePos(): InputBubblePositionDetails | null {
    const posn = super._calculateBubblePos();
    if (posn == null) {
      return null;
    }
    const {top, left, offset, isPositionedAbove} = posn;
    const axisOffset = this.$el.find('.sequenceAxis').offset();
    const parentOffset = this.$el.offset();
    const topPadding = 24;
    const adjustedTop = isPositionedAbove
      ? top + 9 * topPadding
      : axisOffset!.top - parentOffset!.top + topPadding;

    return {top: adjustedTop, left: left + this.$el.scrollLeft(), offset, isPositionedAbove};
  }

  handleArrowPress(e: JQueryEventObject): void {
    e.preventDefault();
    const selection = this.mapstate.get('sequence').get('selection');
    const shift = e.shiftKey;

    const start = selection.start();
    const end = selection.end();

    switch (e.which) {
      case 37: // left arrow
        if (shift) {
          selection.linearExtendBy(-1);
        } else if (selection.isEmpty()) {
          selection.resetBy(-1);
        } else {
          selection.reset(start);
        }
        break;
      case 39: // right arrow
        if (shift) {
          selection.linearExtendBy(1);
        } else if (selection.isEmpty()) {
          selection.resetBy(1);
        } else {
          selection.reset(end);
        }
        break;
      default:
        break;
    }

    this.mapstate.get('sequence').trigger('cursorJump');
  }

  /**
   * Update the slice attributes. Caller is expected to call sliceView.[update|render]() afterwards.
   */
  setSliceValues(noScroll?: boolean | null): void {
    if (noScroll == null) {
      noScroll = false;
    }
    const start = 0;
    const end = this.mapstate.get('sequence').length();
    const width =
      this.mapstate
        .get('layout')
        .DNA.get('type')
        .width(end - start) + this.mapstate.get('layout').DNA.get('type').letterSpacing;

    const x = d3.scaleLinear().clamp(true).domain([start, end]).range([0, width]);
    const xInv = d3.scaleLinear().clamp(true).domain([0, width]).range([start, end]);

    let extra = {};
    if (!noScroll) {
      const scroll = this.$el.scrollLeft();
      const leftBP = Math.floor(
        (scroll / parseInt(d3.select(this.el).select('svg.mini-map').attr('width'), 10)) *
          this.mapstate.get('sequence').length()
      );
      const rightBP = Math.min(
        leftBP + this.type.numChars(this.model.get('bufferViewLayout')!.get('width')),
        this.mapstate.get('sequence').length()
      );
      extra = {leftBP, rightBP};
    }

    const attrs = {start, end, width, x, xInv, maxWidth: width, visibleWidth: this.mapWidth(), ...extra};
    this.slice.set(attrs, {skipUpdate: true}); // Avoid double render: caller will call update
  }

  update(): void {
    const width = this.mapstate.get('layout').DNA.get('type').width(this.mapstate.get('sequence').length());
    d3.select(this.el)
      .select('svg.mini-map')
      .attr('width', width + 1); // we need one extra pixel to show the last tick mark and cursor on the end
    this.setSliceValues();

    if (this.mapstate.get('sequence').length() === 0) {
      this.sliceView.$el.hide();
      return;
    }
    this.sliceView.$el.show();
    if (this.sliceView.hasRendered) {
      this.sliceView.update();
    } else {
      this.sliceView.render();
    }
  }

  override stopListening(...args: Array<unknown>): void {
    super.stopListening(...args);
    if (args.length === 0) {
      $(window).off('.minimap');
    }
  }

  registerLayerHandler(): void {
    const annotations = this.mapstate.get('sequence').annotations();
    const translations = this.mapstate.get('sequence').translations();
    const showInlineOption = this.model.get('visibilityOptions').getOption(vo.INLINE_LABELS.name);

    // Register listeners
    this.listenTo(this.mapstate, 'change:layeringMode', () => {
      this.computeInlineLayers();
      this.sliceView.updateComponent(SliceComponentName.annotations);
      this.sliceView.updateComponent(SliceComponentName.translations);
      this.sliceView.updateComponent(SliceComponentName.partAnnotations);
    });
    this.listenTo(this.slice, 'change:xInv', () => {
      this.computeInlineLayers();
      // Updating is only necessary if we are using inline layers.
      if (showInlineOption?.get('visible')) {
        this.sliceView.updateComponent(SliceComponentName.annotations);
        this.sliceView.updateComponent(SliceComponentName.translations);
        this.sliceView.updateComponent(SliceComponentName.partAnnotations);
      }
    });
    this.listenTo(annotations, 'layerChange', () => {
      this.computeInlineLayers();
      this.sliceView.updateComponent(SliceComponentName.annotations);
      this.sliceView.updateComponent(SliceComponentName.partAnnotations);
    });
    this.listenTo(translations, 'layerChange', () => {
      this.computeInlineLayers();
      this.sliceView.updateComponent(SliceComponentName.translations);
    });
    this.listenTo(
      this.slice,
      'change:rightBP',
      throttle(() => {
        this.computeInlineLayers();
        this.sliceView.updateComponent(SliceComponentName.annotations);
        this.sliceView.updateComponent(SliceComponentName.translations);
        this.sliceView.updateComponent(SliceComponentName.partAnnotations);
      }, 100)
    );
    // Set layers for initial render
    this.computeInlineLayers();
  }

  computeInlineLayers(): void {
    const showInline = LINEAR_INLINE_LAYERS.includes(this.mapstate.get('layeringMode'));
    if (showInline) {
      this.mapstate.setInlineLayers(this.slice);
    }
  }

  updateZoomAndSlice(): void {
    this.sliceView.dontUpdate = true;
    this.setZooms();
    this.sliceView.dontUpdate = false;
    this.update();
  }

  override registerListeners(): void {
    super.registerListeners();
    const cutsites = this.mapstate.get('sequence').get('cutsites');
    CutsiteMap.addListeners(this, cutsites, this.debouncedUpdateCutsiteData);
    this.listenTo(this.slice, 'change:width', this.debouncedUpdateCutsiteData);

    // Defer minimap re-render to ensure that on page resize / sidebar expand, that the sequence map is able
    // to render and be drawn to the screen, since otherwise, it is stuck with a large white gap while the
    // minimap is re-rendering.
    this.listenTo(this.model.get('bufferViewLayout'), 'change:width', () => {
      _.defer(() => {
        this.updateZoomAndSlice();
      });
    });

    this.listenTo(
      this.mapstate.get('sequence').get('dna'),
      'change:forward',
      this.updateZoomAndSlice.bind(this)
    );
    this.listenTo(this.mapstate, 'change:fontWidthZoom', this.handleZoom.bind(this));
    this.listenTo(this.mapstate.get('sequence'), 'jump', this.goToBase.bind(this));
    this.listenTo(
      this.mapstate.get('sequence').sequencePrimers(),
      'layerChange',
      // eslint-disable-next-line no-restricted-syntax
      _.bind(() => {
        this.sliceView.updateComponent(SliceComponentName.primers);
      }, this)
    );
    this.listenTo(this.mapstate.get('sequence').get('_sequence'), 'change:parts', this.update.bind(this));
    this.listenTo(this.mapstate.get('sequence').orfs(), 'reset', () => {
      this.sliceView.updateComponent(SliceComponentName.orfs);
    });
    this.registerLayerHandler();

    $(window).on('mouseup.minimap', () => {
      this.updateSelection();
    });

    d3.select(this.el).on(`${MouseWheelEvent}.minimap`, (e: ElementWheelEvent & {wheelDelta?: number}) => {
      const r = e.wheelDelta
        ? e.wheelDelta
        : e.detail
          ? e.detail * -40
          : e && e.wheelDelta
            ? e.wheelDelta
            : 0;

      if (e.ctrlKey) {
        this.mapstate.zoomByFactor(Math.pow(2, r / 480));
        e.preventDefault();
      }
    });
  }

  updateCutsiteData(): void {
    const slices = this.makeSlicesForCutsites();
    if (window.snapshot) {
      for (const slice of slices) {
        slice.set('cutData', []);
      }
    } else {
      sequtil.setCutsiteData(this.mapstate.get('sequence'), slices, this.maxBases());
      slices[0].set('cutData', this.cutsiteFilter(slices[0].get('cutData')));
    }
  }

  makeSlicesForCutsites(): Array<Slice> {
    // MiniMap always has one slice, so we can reuse it.
    return this.slices.models;
  }

  cutsiteFilter(cuts: Array<CutSite>): Array<CutSite> {
    const sequence = this.mapstate.get('sequence');
    const tabstate = this.model;

    // Filter if there are too many things.
    // Try removing things from the shown cutsites until it is an appropriate level.
    const paths = {
      [EnzymeType.ALL]: [EnzymeType.SINGLEANDDOUBLE, EnzymeType.DOUBLE, EnzymeType.SINGLE, EnzymeType.NONE],
      [EnzymeType.SINGLEANDDOUBLE]: [EnzymeType.DOUBLE, EnzymeType.SINGLE, EnzymeType.NONE],
      [EnzymeType.DOUBLE]: [EnzymeType.NONE],
      [EnzymeType.SINGLE]: [EnzymeType.NONE],
      [EnzymeType.NONE]: [],
    };

    function getCutsites(oldCutsites: Array<CutSite>): Array<CutSite> {
      const CUTSITE_CAP = 1000;

      // If in the worst case (where we only show selected cutsites) there are too many cutsites,
      // we will iteratively blacklist enzymes.
      const visibleEnzymes = sequence
        .get('enzymes')
        .filter((enzyme) => enzyme.isVisibleByCuts(EnzymeType.NONE, []));
      const enzymes = _.sortBy(visibleEnzymes, (enzyme) => -enzyme.get('cutPositions').length);
      let numberCuts = enzymes.reduce((memo, enzyme) => memo + enzyme.get('cutPositions').length, 0);
      const blackListed: Array<Enzyme> = [];
      while (numberCuts > CUTSITE_CAP) {
        const enzyme = enzymes.shift()!;
        numberCuts -= enzyme.get('cutPositions').length;
        blackListed.push(enzyme);
      }

      const panelState = sequence.get('fileState')?.get('toolbar').get('restrictionPanelState');
      const viewEnzymes = panelState != null ? panelState.get(EnzymePreferences.VIEW_ENZYMES) : undefined;
      const originalOption: EnzymeType = viewEnzymes || EnzymeType.ALL;

      const options = paths[originalOption];

      // If its still bad, lets try to reduce the option.
      const newCutsites = oldCutsites.filter((cutsite) =>
        cutsite.get('enzyme').isVisibleByCuts(originalOption, [])
      );
      if (newCutsites.length > CUTSITE_CAP) {
        for (const option of options) {
          const cutsites = newCutsites.filter((cutsite) => cutsite.get('enzyme').isVisibleByCuts(option, []));
          if (cutsites.length <= CUTSITE_CAP) {
            if (option === EnzymeType.NONE && enzymes.length === 0) {
              tabstate.set('cutsiteFilter', {before: originalOption, after: null, blackList: []});
            } else {
              tabstate.set('cutsiteFilter', {
                before: originalOption,
                after: option,
                blackList: blackListed,
              });
            }
            return cutsites;
          }
        }
        tabstate.set('cutsiteFilter', {
          before: originalOption,
          after: null,
          blackList: blackListed,
        });
        return [];
      } else {
        tabstate.set('cutsiteFilter', {
          before: originalOption,
          after: originalOption,
          blackList: blackListed,
        });
        return newCutsites;
      }
    }

    return getCutsites(cuts);
  }

  getSVGNode(): HTMLElement {
    return this.$el.children('svg')[0];
  }

  override render(): this {
    Perf.markStart(this.mapLoadPerfId);
    super.render();

    const svg = d3
      .select(this.el)
      .append('svg:svg')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
      .classed('mini-map', true)
      .classed(this.sliceView.className, true);

    if (!window.snapshot) {
      const title = d3
        .select(this.el)
        .append('svg:svg')
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
        .classed('mini-map-title', true)
        .classed(this.sliceView.className, true)
        .attr('width', this.model.get('bufferViewLayout')!.get('width'));
      const titleContainer = title.append('svg:g');
      this.titleView = new TitleView({
        el: titleContainer.node(),
        model: this.mapstate,
        // @ts-expect-error slice exists on TitleViewOptions
        slice: this.slice,
        bufferCentred: true,
      });
      title.attr('height', this.titleView.layout.boxHeight() + 10);
      this.titleView.render();
    }

    this.setZooms();
    this.updateCutsiteData();
    this.sliceView.setElement(svg.node());
    this.sliceView.setFocusableParent(this.el);
    this.registerListeners();
    this.update();
    Perf.markEnd(this.mapLoadPerfId);
    return this;
  }

  override afterAttach(): void {
    this.restoreScroll();
  }
}
MiniMap.initClass();

export {MiniMap as MiniMapTabView};
